export default __webpack_public_path__ + "static/media/lavafloor.5befae92.png";